module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_th-e41925ba3be697a4a4f82b37771c4454.jpg";